import Debug from './debug';
import EventManager from "./event_manager";
import AppData from '../pacakge/public/const/app_data';
import { AssetVersionDataDetail, GameManager } from './game_manager';
import LogManager from './log_manager';
import Utility from '../utility/utility';


const { ccclass, property } = cc._decorator;


@ccclass
export default class VersionManager {

    public static readonly instance: VersionManager = new VersionManager();

    private assetsStoragePath : string ;
    private assetManager : any;

    private updating: boolean;

    private customManifest

    private remoteAssetVersion = 0

    private _retryCount = 0

    private assets
    private assetVersion

    private _errorDownloadManifestFile = false


    public init() {
        //@ts-ignore
        let windowAppData = window.appData
        if (windowAppData) {
            this.assets = windowAppData.assets
        } else {
            if (CC_PREVIEW && AppData.versionConfigUrl) {
                let manifestUrl = jsb.fileUtils.getWritablePath() + 'remote-assets/' + AppData.appVersion + '/project.manifest'
                cc.log("getWritablePath", manifestUrl)
                if (jsb.fileUtils.isFileExist(manifestUrl)) {
                    let strContent = jsb.fileUtils.getStringFromFile(manifestUrl)
                    if (strContent) {
                        let manifestData = JSON.parse(strContent)
                        this.assets = manifestData.assets
                        this.assetVersion = parseInt(manifestData.version)
                        AppData.assetVersion = this.assetVersion
                    }
                }
            }
        }
        cc.log("VersionManager init", AppData.assetVersion, jsb.fileUtils.getSearchPaths(), jsb.fileUtils.getWritablePath() + 'remote-assets/' + AppData.appVersion)
    }

    public startUpdateVersion(configVersionData : AssetVersionDataDetail) {
        if (this.updating) {
            cc.warn("正在更新，不能重复尝试")
            return
        }
        this.updating = true
        cc.log("startUpdateVersion", AppData.assetVersion, configVersionData.version, this.remoteAssetVersion, configVersionData.remoteManifestUrl)
        this.customManifest = JSON.stringify({
            "packageUrl" : "",
            "remoteManifestUrl" : configVersionData.remoteManifestUrl,
            "version" : AppData.assetVersion.toString(),
            "assets" : this.assets
        })
        // cc.error(this.customManifest)
        this.remoteAssetVersion = parseInt(configVersionData.version)

        this.checkVersion()
    }

    public checkVersion(){
        this._errorDownloadManifestFile = false
        this.assetsStoragePath = jsb.fileUtils.getWritablePath() + 'remote-assets/' + AppData.appVersion + "/";
        cc.log('Storage path for remote asset : ' + this.assetsStoragePath);
        if (jsb.fileUtils.isFileExist(this.assetsStoragePath + '/project.manifest')) {
            jsb.fileUtils.renameFile(this.assetsStoragePath, '/project.manifest', '/project.manifest.backup')
        }

        this.assetManager = new jsb.AssetsManager('', this.assetsStoragePath, this.versionCompareHandle.bind(this))

        this.assetManager.loadLocalManifest(new jsb.Manifest(this.customManifest, this.assetsStoragePath), this.assetsStoragePath);

        // Setup the verification callback, but we don't have md5 check function yet, so only print some message
        // Return true if the verification passed, otherwise return false
        this.assetManager.setVerifyCallback(function (path, asset) {
            // When asset is compressed, we don't need to check its md5, because zip file have been deleted.
            var compressed = asset.compressed;
            // Retrieve the correct md5 value.
            var expectedMD5 = asset.md5;
            // asset.path is relative path and path is absolute.
            var relativePath = asset.path;
            // The size of asset file, but this value could be absent.
            var size = asset.size;

            if (compressed) {
                return true;
            }
            else {
                return true;
            }
        });


        if (cc.sys.os === cc.sys.OS_ANDROID) {
            // Some Android device may slow down the download process when concurrent tasks is too much.
            // The value may not be accurate, please do more test and find what's most suitable for your game.
            this.assetManager.setMaxConcurrentTask(5);
        }
        this.assetManager.setEventCallback(this.updateEvent.bind(this));
        this.assetManager.update();
    }

    // Setup your own version compare handler, versionA and versionB is versions in string
    // if the return value greater than 0, versionA is greater than versionB,
    // if the return value equals 0, versionA equals to versionB,
    // if the return value smaller than 0, versionA is smaller than versionB.
    private versionCompareHandle (versionA, versionB) {
        cc.log("Version Compare: versionA is " + versionA + ', versionB is ' + versionB);
        let versionAA =  parseInt(versionA)
        let versionBB =  parseInt(versionB)
        versionAA = isNaN(versionAA) ?  0 : versionAA
        versionBB = isNaN(versionBB) ?  0 : versionBB
        return versionAA - versionBB
    }



    public updateEvent(event) {
        switch (event.getEventCode())
        {
            case jsb.EventAssetsManager.ERROR_NO_LOCAL_MANIFEST:
            case jsb.EventAssetsManager.ERROR_DOWNLOAD_MANIFEST:
            case jsb.EventAssetsManager.ERROR_PARSE_MANIFEST:
                this._errorDownloadManifestFile = true
                this._UpdateEventDispatch("error_download_manifest_file");
                break;
            case jsb.EventAssetsManager.NEW_VERSION_FOUND:
                this._retryCount = 0
                this._UpdateEventDispatch("new_version_found");
                break;
            case jsb.EventAssetsManager.ALREADY_UP_TO_DATE:
                this.updating = false;
                this._UpdateEventDispatch("already_up_to_date");
                break;
            case jsb.EventAssetsManager.UPDATE_PROGRESSION:     
                let downBytes = Number(event.getDownloadedBytes());
                let totalBytes = Number(event.getTotalBytes());         
                let progress = totalBytes == 0 ?  0 :  Number((downBytes / totalBytes).toFixed(2));
                this._UpdateEventDispatch("update_progress",progress);
                break;
            case jsb.EventAssetsManager.ASSET_UPDATED:
                // this._UpdateEventDispatch("asset updated", event.getAssetId());
                break;
            case jsb.EventAssetsManager.ERROR_UPDATING:  //会经常出现下载失败的情况
                    this._UpdateEventDispatch("asset update error",event.getAssetId());
                    break;
            case jsb.EventAssetsManager.UPDATE_FINISHED:
                this._UpdateEventDispatch("update_progress",1);
                this._UpdateEventDispatch("update_finished",event.getMessage());
                this._UpdateFinish()
                break;
            case jsb.EventAssetsManager.UPDATE_FAILED:
                this.updating = false;
                this._UpdateEventDispatch("update_failed",event.getMessage());
                break;

            case jsb.EventAssetsManager.ERROR_DECOMPRESS:
                this.updating = false;
                this._UpdateEventDispatch("error_decompress", event.getMessage());
                break;
            default:
                cc.log(" updateCb default :"  + event.getEventCode(), event.getMessage());
                break;
        }
    }    


    private _UpdateEventDispatch(eventName: string, data?) {
        if ((eventName == "error_download_manifest_file" || eventName == "update_failed") && ++this._retryCount < 4) {
            if (eventName == "error_download_manifest_file") {
                this.checkVersion()
            } else {
                this.assetManager.downloadFailedAssets();
            }
        } else {
            EventManager.instance.dispatch(eventName, data);
        }
        if (eventName != "update_progress") {
            let errorInfo = eventName + " - " + this.assetManager.getState()
            if (data) {       
                cc.log(errorInfo, data)
            } else {
                cc.log(errorInfo)
            }
        }
    }
    
    private _UpdateFinish() {
        this.assetManager.setEventCallback(null);
        if (CC_PREVIEW) {
            cc.warn("更新完成，模拟器下不能重启只能关闭");
            // cc.game.end()
            return
        }
        Utility.reportConversionEvent(`sys_upate_version_end`)
        setTimeout(function() {
            GameManager.reboot()
        }, 200)
    }

    //如果重试次数过多的话
    public retry() {
        if (++this._retryCount > 10) {
            cc.error("错误更新次数太多，触发重启")
            cc.audioEngine.stopAll();
            cc.game.restart();
            return
        }
        if (this._errorDownloadManifestFile) {
            this.checkVersion()
        } else {
            this.assetManager.downloadFailedAssets();
        }
    }

    public clearStorage(){

        let storagePath = jsb.fileUtils.getWritablePath();
        jsb.fileUtils.removeDirectory(storagePath);
    }

    
}

